<template>
  <div class="nodata" :style="defineStyle">
    <div
      class="nodata-icon"
      :class="{ failPending: type }"
      :style="{
        backgroundImage: `url(${imgUrl})`,
      }"
    ></div>
    <div class="tip">
      <div>{{ tip }}</div>
      <div>{{ tipLine2 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tip: {
      type: String,
      default: () => "推荐好友立马拿佣金",
    },
    tipLine2: {
      type: String,
      default: () => "",
    },
    defineStyle: {
      type: String,
      default: "",
    },
    imgUrl: {
      type: String,
      default() {
        return require("@/common/images/recommend/no-record_icon.png");
      },
    },
    type: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.nodata {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .nodata-icon {
    width: 220px;
    height: 268px;
    margin-bottom: 18px;
    background-size: 100% 100%;
  }
  .failPending {
    width: 416px;
    height: 230px;
  }
  .tip {
    // width: 220px;
    font-size: 24px;
    color: #333333;
    text-align: center;
  }
}
</style>
